import React from 'react';
import { Button, Space, Typography } from 'antd';
import {
  bool, func, node, number, oneOfType, string,
} from 'prop-types';
import { ExpandMoreIcon } from 'components/cwo-icons';

const { Text } = Typography;

const ToggleBtn = ({
  additionalContent = null,
  dispatcherTimerContent = null,
  showDrawer,
  showExpandIcon = true,
  loadMenuData,
  iconBackgroundColor,
  toggleKey,
  label,
  value,
  isVisible = true,
  icon,
  id,
}) => (
  isVisible && (
    <Button
      className="top-menu-field-groups__toggle-btn"
      onClick={() => showDrawer(toggleKey)}
      onMouseOver={loadMenuData}
      type="link"
      id={id}
    >
      {additionalContent}
      <span
        style={{ background: iconBackgroundColor }}
        className="top-menu-field-groups__btn-icon-container"
      >
        {icon}
      </span>
      <Space direction="vertical" size={0} align="start">
        <Text type="secondary" className="top-menu-field-groups__btn-text-container__label">
          {label}
        </Text>
        <Text>
          {dispatcherTimerContent}
          {value}
        </Text>
      </Space>
      {showExpandIcon && <ExpandMoreIcon />}
    </Button>
  )
);

ToggleBtn.propTypes = {
  showDrawer: func.isRequired,
  loadMenuData: func.isRequired,
  iconBackgroundColor: string.isRequired,
  toggleKey: number.isRequired,
  label: string.isRequired,
  value: oneOfType([string, number]).isRequired,
  isVisible: bool,
  showExpandIcon: bool,
  additionalContent: node,
  icon: node.isRequired,
  id: string.isRequired,
  dispatcherTimerContent: node,
};

export default ToggleBtn;
